/** Enforcing theme tokens to be used for default */
const themeTokens = {
    primaryColor: 'var(--ant-primary-color)',
    hoveredPrimaryColor: 'var(--ant-primary-color-hover)',
    textColor: '#fff',

    baseFontSize: '1rem',
    buttonFontSize: '1rem',
    inputFontSize: '1rem',

    inputFieldHeight: '34px',
};

export default themeTokens;
